import { DeploymentUnitOutlined } from '@ant-design/icons';
import { t } from '../../../languages';

import { Avatar, Button, Spin } from 'antd';
import MyCountDown from '../../Utils/time/MyCountDown';
import StudentList from './StudentList';
import { useState } from 'react';


// Opened -> wait students to join
const CompetitionStage2 = ({ lang, theCompetition, theClass, handleStartCompetition }) => {
    const [step, setStep] = useState(1);

    const students = theCompetition ? theCompetition.participants : null;
    const numStudents = students ? students.length : 0;

    const _handleStartCompetition = () => {
        setStep(2);
    }

    const _handleTimeout = () => {
        // console.log('MyCountDown timeout: lauch exercise!!');
        handleStartCompetition();
    }

    if (step === 1) {
        return <>
            <div className="create-class-code">
                <h3>{t(lang, 'classcode')}:</h3>
                <h2 className='code'>{theClass.code}</h2>
                <br />
                <p>
                    {t(lang, 'inviteStudents')} <button className="fake-button button-yellow">{t(lang, 'joinClass')}</button>, {t(lang, 'thenAccessCompetition')} <Avatar
                        size="medium" shape="square" src={`./static/menu/minitournament.svg`} /> {t(lang, 'onthe')}  <span>App MiSoroban</span> {t(lang, 'orInApp')} <span>app.misoroban.com</span>.
                </p>

            </div>

            <div className='waiting'>
                <Spin size="large" className="spinner" />
                <h3 className="code">{t(lang, 'waitingparticipants')}</h3>
                <br />
                <Button disabled={!numStudents} type="primary" className="button-blue" onClick={_handleStartCompetition}>
                    <DeploymentUnitOutlined /> {t(lang, 'start')}
                </Button>
            </div>

            <br />

            <StudentList lang={lang} students={students} />


        </>;
    } else {
        return <>
            <div className="create-class-code">
                <p>
                    {t(lang, 'preparetostart')}
                </p>
            </div>

            <div className='count-down'><MyCountDown
                timeout={3}
                stopTime={false}
                timeHandler={_handleTimeout} />
            </div>
        </>;
    }
}

export default CompetitionStage2;